(function () {
  var AUTO_OPEN_TOTAL_DELAY = 5000;
  var SESSION_TTL_MS = 60 * 60 * 1000;
  var SESSION_START_KEY = 'freshchat_auto_open_session_start_v1';
  var SESSION_ELAPSED_KEY = 'freshchat_auto_open_session_elapsed_v1';
  var SESSION_SEEN_KEY = 'freshchat_auto_open_seen_v1';
  var SESSION_DISMISSED_KEY = 'freshchat_auto_open_dismissed_v1';
  var PAGE_START_AT = Date.now();
  var timerId = null;
  var bound = false;
  var pageElapsedPersisted = false;

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function storageRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {}
  }

  function getSessionStartAt() {
    return Number(storageGet(SESSION_START_KEY) || 0);
  }

  function getSessionElapsed() {
    return Number(storageGet(SESSION_ELAPSED_KEY) || 0);
  }

  function getCurrentElapsed() {
    var sessionStartAt = getSessionStartAt();
    var storedElapsed = getSessionElapsed();

    if (!sessionStartAt) {
      return storedElapsed;
    }

    return storedElapsed + Math.max(0, Date.now() - PAGE_START_AT);
  }

  function resetSession() {
    storageSet(SESSION_START_KEY, String(Date.now()));
    storageSet(SESSION_ELAPSED_KEY, '0');
    storageRemove(SESSION_SEEN_KEY);
    storageRemove(SESSION_DISMISSED_KEY);
  }

  function ensureSession() {
    var sessionStartAt = getSessionStartAt();
    var storedElapsed = getSessionElapsed();
    var sessionExpired = sessionStartAt && (Date.now() - sessionStartAt > SESSION_TTL_MS);

    if (!sessionStartAt || sessionExpired) {
      resetSession();
      return;
    }

    if (storedElapsed >= AUTO_OPEN_TOTAL_DELAY) {
      storageSet(SESSION_SEEN_KEY, '1');
    }
  }

  function canAutoOpen() {
    return storageGet(SESSION_SEEN_KEY) !== '1' && storageGet(SESSION_DISMISSED_KEY) !== '1';
  }

  function markSeen() {
    storageSet(SESSION_SEEN_KEY, '1');
  }

  function markDismissed() {
    storageSet(SESSION_DISMISSED_KEY, '1');
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }
  }

  function persistPageElapsed() {
    if (pageElapsedPersisted) {
      return;
    }

    var sessionStartAt = getSessionStartAt();
    if (!sessionStartAt) {
      return;
    }

    var nextElapsed = getSessionElapsed() + Math.max(0, Date.now() - PAGE_START_AT);
    storageSet(SESSION_ELAPSED_KEY, String(nextElapsed));
    pageElapsedPersisted = true;

    if (nextElapsed >= AUTO_OPEN_TOTAL_DELAY) {
      markSeen();
    }
  }

  function getRemainingDelay() {
    return Math.max(0, AUTO_OPEN_TOTAL_DELAY - getCurrentElapsed());
  }

  function openWidgetIfReady() {
    if (!window.fcWidget || typeof window.fcWidget.open !== 'function') {
      return;
    }

    if (!canAutoOpen()) {
      return;
    }

    if (typeof window.fcWidget.isOpen === 'function' && window.fcWidget.isOpen()) {
      markSeen();
      return;
    }

    markSeen();
    window.fcWidget.open();
  }

  function scheduleAutoOpen() {
    if (!window.fcWidget || typeof window.fcWidget.open !== 'function') {
      return;
    }

    if (timerId || !canAutoOpen()) {
      return;
    }

    var remainingDelay = getRemainingDelay();

    if (remainingDelay <= 0) {
      openWidgetIfReady();
      return;
    }

    timerId = window.setTimeout(function () {
      timerId = null;
      openWidgetIfReady();
    }, remainingDelay);
  }

  function bindAutoOpen() {
    if (!window.fcWidget || typeof window.fcWidget.on !== 'function') {
      window.setTimeout(bindAutoOpen, 250);
      return;
    }

    if (bound) {
      return;
    }

    bound = true;

    ensureSession();

    window.fcWidget.on('widget:opened', function () {
      markSeen();
    });

    window.fcWidget.on('widget:closed', function () {
      markDismissed();
    });

    if (typeof window.fcWidget.isLoaded === 'function' && window.fcWidget.isLoaded()) {
      scheduleAutoOpen();
      return;
    }

    window.fcWidget.on('widget:loaded', function () {
      scheduleAutoOpen();
    });
  }

  window.addEventListener('pagehide', persistPageElapsed, false);
  window.addEventListener('beforeunload', persistPageElapsed, false);

  if (document.readyState === 'complete') {
    bindAutoOpen();
  } else {
    window.addEventListener('load', bindAutoOpen, false);
  }
})();
